<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-play-later`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M34 22c6.627 0 12 5.373 12 12s-5.373 12-12 12-12-5.373-12-12 5.373-12 12-12zm0 4a8 8 0 100 16 8 8 0 000-16zm2-24a2 2 0 012 2v16h-4V6H6v28h14v4H4a2 2 0 01-2-2V4a2 2 0 012-2h32zm-1 26a1 1 0 011 1v3h3a1 1 0 011 1v2a1 1 0 01-1 1h-6a1 1 0 01-1-1v-6a1 1 0 011-1h2zM16 13.08a1 1 0 01.625.22l7.399 5.92a1 1 0 010 1.56l-7.4 5.92A1 1 0 0115 25.92V14.08a1 1 0 011-1z"/></svg>
</template>
<script>

export default {
  name: 'IconPlayLater',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
